/*
Created By Sharifuzzaman Nakib on 6 October, 2021
*/

export enum SupportIssues  {
  General = "General",
  Feedback = "Feedback",
  OrbitaxServices = "Orbitax Services",
  OrbitaxSales = "Orbitax Sales",
  TaxDomain = "Tax domain",
  TechnicalSupport = "Technical Support"
}
